<template>
<div class="coupon-box mdc-typography mdc-typography mdc-typography--body2">
  <separator />
  <div class="coupon-box__content">
    <div class="coupon-box__content__title">{{ $t('COUPON.TITLE') }}</div>
    <div class="coupon-box__content__code">
      <span>{{ coupon }}</span>
      <i v-if="valid" class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing">check</i>
      <i v-else class="material-icons invalid mdc-text-field__icon mdc-text-field__icon--trailing">cancel</i>
    </div>
    <div class="coupon-box__content__invalid" v-if="!valid">{{ $t('COUPON.INVALID') }}</div>
  </div>
</div>
</template>
<script>
import BkInput from '../../../common/BkInput'
import { mapMutations, mapState } from 'vuex'
import Separator from '../components/Separator'
export default {
  components: { Separator, BkInput },
  computed: {
    ...mapState(['coupon']),
    valid() {
      return this.coupon === '1mp3d5MJ6'
    }
  },
  data() {
    return {
      pristine: true,
    }
  },
  methods: {
    ...mapMutations(['updateCoupon'])
  },
}
</script>
<style lang="scss" scoped>
  @import "../../../scss/colors";
  @import "../../../scss/variables";

  .coupon-box {
    overflow: hidden;

    &__content {
      background: $premium;
      border-radius: 4px;
      margin: 16px;
      padding: 16px;

      &__title {
        color: #323232;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 21px;
        text-align: center;
        margin-bottom: 12px;
      }

      &__code {
        display: flex;
        flex-direction: row;
        align-content: flex-start;
        justify-content: space-between;

        background: $on-premium;
        border-radius: 4px;
        font-size: 20px;
        line-height: 48px;
        padding: 0 0 0 12px;
      }

      &__invalid {
        margin-top: 4px;
        font-size: 12px;
        text-align: center;
      }
    }
  }

  .material-icons {
    color: $feedback;
    padding-right: 8px;

    &.invalid {
      color: $error;
    }
  }
</style>

